<template>
  <div>
    <header-bar>YouTubeマネタイズ</header-bar>
    <div>
      <div class="page-block">
        <div class="page-block__heading page-block__heading--withbar">
          <h3 class="page-block__title">申し立てレポート</h3>
        </div>
        <div class="page-block__inner">
          <div
            v-if="selectedAsset"
            class="youtube-search-wrap"
            style="margin-bottom: 22px;">
            <label>
              選択中のアセット:
              <b>{{ selectedAsset.metadata.title }}({{ selectedAsset.id }})</b>
            </label>
            <a
              href="#"
              class="c-text-link"
              @click.prevent="onAssetRowClicked('')">
              選択を解除
            </a>
          </div>
          <div
            v-else
            class="youtube-btn-wrap">
            <div
              class="youtube-search-wrap"
              style="margin-bottom: 22px;">
              <input
                v-model="keyword"
                class="youtube-search"
                placeholder="アセット名、ISRC、タイトル"
                type="search"
                @search="onClickedSearch('', $event)"
                @keydown.prevent.enter="onClickedSearch('enter', $event)">
              <a
                class="c-btn c-btn--search"
                @click.prevent="onClickedSearch('',$event)">
                <img src="/img/common/icon-search.png" />検索
              </a>
            </div>
          </div>
          <asset-table
            v-if="!selectedAsset && assets.length > 0"
            :items="assets"
            select-button-text="レポートを見る"
            @row-clicked="onAssetRowClicked" />

          <template v-if="reports.length > 0">
            <date-range-selector
              :default-range-mode="summaryType"
              :default-ranges="ranges"
              @input="onChangeMode"
              @change-range="onChangeRange" />
            <div style=" background-color: #f3f3f1; padding: 12px 20px;max-width: 500px">
              <div
                style="display: flex; justify-content: space-between">
                <div style="width: 150px">
                  集計期間
                </div>
                <div style="width: 250px; text-align: right">
                  {{ reportRanges[0] }} ~ {{ reportRanges[1] }}
                </div>
              </div>
              <div
                style="display: flex; justify-content: space-between">
                <div style="width: 250px">
                  視聴回数
                </div>
                <div style="width: 150px; text-align: right">
                  {{ assetTotal.views | number }} 回
                </div>
              </div>
              <div
                style="display: flex; justify-content: space-between">
                <div style="width: 250px">
                  パートナーの推定収益
                </div>
                <div style="width: 150px;text-align: right">
                  {{ assetTotal.estimatedRevenue | number }} 円
                </div>
              </div>
            </div>
            <report-table
              :reports="reports"
              :sort-key="sortKey"
              :sort-order="sortOrder"
              @on-change-sort="onChangeSort" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../../../HeaderBar'
import YouTubeAssetsAssetTable from '../../Assets/AssetTable'
import DateRangeSelector from '../../../Report/DateRangeSelector'
import ReportTable from './ReportTable'

export default {
  name: 'YouTubeClaimsIndex',
  components: {
    HeaderBar,
    AssetTable: YouTubeAssetsAssetTable,
    DateRangeSelector,
    ReportTable,
  },
  data() {
    return {
      type: 1,
      keyword: '',
      assetId: null,
      pageIndex: 0,
      error: null,
      errorMessage: null,
      selectedAsset: null,
      assets: [],
      videos: [],
      reports: [],
      reportedDate: null,
      ranges: [],
      summaryType: 'last7d',
      sortKey: 'views',
      sortOrder: false,
      assetTotal: {
        views: 0,
        estimatedRevenue: 0,
      },
      reportRanges: [],
    }
  },
  mounted() {
    if (this.$route.query.keyword) {
      this.keyword = this.$route.query.keyword
      this.fetchItems(this.keyword)
    }
    if (this.$route.query.asset_id) {
      if (this.$route.query.page_index) {
        this.pageIndex = parseInt(this.$route.query.page_index ?? 0, 10)
      }
      if (this.$route.query.ranges) {
        this.ranges = this.$route.query.ranges
      }
      if (this.$route.query.summary_type) {
        this.summaryType = this.$route.query.summary_type
      }
      if (this.$route.query.sort) {
        this.sortKey = this.$route.query.sort
      }
      if (this.$route.query.order) {
        this.sortOrder = !!this.$route.query.order
      }
      this.assetId = this.$route.query.asset_id
      // this.fetchAsset(this.assetId)
      this.fetchReport(this.assetId)
    }
  },
  methods: {
    onClickedSearch(type, event) {
      if (type === 'enter' && event.keyCode !== 13) {
        return
      }
      this.$emit('change', this.keyword)
      if (this.keyword === '' || this.keyword === null) {
        this.assets = []
        this.selectedAsset = null
        this.sortKey = 'views'
        this.sortOrder = false
        return
      }
      this.fetchItems(this.keyword, true)
    },
    async fetchItems(keyword, reload = false) {
      this.loading = true
      this.errorMessage = null
      this.assets = []
      this.selectedAsset = null
      this.error = null
      try {
        // 検索結果を取得
        const { data } = await window.axios.get('/api/client/youtube/assets/search', {
          params: {
            keyword,
          },
        })
        this.assets = data
        if (reload) {
          const query = { ...this.$route.query }
          if (keyword === '') {
            delete query.keyword
          } else {
            query.keyword = keyword
          }
          this.$router.push({ name: 'youtube-claims-report-index', query }, () => {
          })
        }
      } catch (e) {
        const { response } = e
        const { status } = response
        if (status === 404) {
          this.assets = []
          this.errorMessage = '検索結果が見つかりませんでした'
        }
        this.error = e
      }
      this.loading = false
    },
    onAssetRowClicked(assetId) {
      this.reports = []
      this.videos = []
      this.assetTotal = {
        views: 0,
        estimatedRevenue: 0,
      }
      this.sortKey = 'views'
      this.sortOrder = false
      if (!assetId) {
        const query = { ...this.$route.query }
        delete query.sort
        delete query.order
        delete query.asset_id
        delete query.summary_type
        this.$router.push({ name: 'youtube-claims-report-index', query }, () => {})
        this.selectedAsset = null
        return
      }
      // this.fetchAsset(assetId, true)
      this.fetchReport(assetId, true)
    },
    async fetchAsset(assetId, reload = false) {
      try {
        // 検索結果を取得
        const { data } = await window.axios.get(`/api/client/youtube/assets/${assetId}`)
        this.selectedAsset = data.asset
        if (reload) {
          this.assetId = assetId
          const query = { ...this.$route.query }
          if (assetId === '') {
            delete query.asset_id
          } else {
            query.asset_id = assetId
          }
          this.$router.push({ name: 'youtube-claims-report-index', query }, () => {})
        }
      } catch (e) {
        const { response } = e
        const { status } = response
        if (status === 404) {
          this.selectedAsset = null
          this.errorMessage = '検索結果が見つかりませんでした'
        }
        this.error = e
      }
    },
    async fetchReport(assetId, reload = false) {
      this.selectedAsset = {}
      if (reload) {
        this.assetId = assetId
        const query = { ...this.$route.query }
        if (assetId === '') {
          delete query.asset_id
        } else {
          query.asset_id = assetId
        }
        this.$router.push({ name: 'youtube-claims-report-index', query }, () => {})
      }
      try {
        // 検索結果を取得
        const { data } = await window.axios.get('/api/client/youtube/reports', {
          params: {
            summary_type: this.summaryType,
            start_date: this.ranges[0] ?? null,
            end_date: this.ranges[1] ?? null,
            asset_id: assetId,
            sort: this.sortKey,
            order: this.sortOrder ? 1 : 0,
          },
        })

        const {
          videos,
          reports,
          total,
          ranges,
          asset,
        } = data
        this.videos = videos
        this.reports = reports
        this.assetTotal = total
        this.reportRanges = ranges
        this.selectedAsset = asset
      } catch (e) {
        this.error = e
      }
    },
    onChangeRange(value) {
      this.ranges = value
      const query = { ...this.$route.query }
      query.summary_type = 'custom'
      query.ranges = value
      this.$router.push({ name: 'youtube-claims-report-index', query }, () => {})
      this.fetchReport(this.assetId)
    },
    onChangeMode(value) {
      this.summaryType = value
      const query = { ...this.$route.query }
      if (value !== 'custom') {
        delete query.ranges
      }
      query.summary_type = value
      this.$router.push({ name: 'youtube-claims-report-index', query }, () => {})
      this.fetchReport(this.assetId)
    },
    onChangeSort(value) {
      if (this.sortKey === value) {
        this.sortOrder = !this.sortOrder
      }
      this.sortKey = value
      const query = { ...this.$route.query }
      query.sort = this.sortKey
      query.order = this.sortOrder ? 1 : 0
      this.$router.push({ name: 'youtube-claims-report-index', query }, () => {})
      this.fetchReport(this.assetId)
    },
  },
}
</script>

<!--@input="onChangeMode"-->
<!--@change-range="onChangeRange"-->
<!--@dateChanged="reportedDate=$event"  />-->
<style scoped>
.error-message {
  color: #ff0000;
  font-size: 16px;
  margin: 20px auto 120px 20px;
  text-align: left;
}
</style>
